import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import type { PhoneScreenView } from '@nest-recruit/shared';
import { Switch } from '../../../components/Switch';
import { useSwitchPhoneScreen } from '../api/phone-screen-api';
import styles from './phone-screen-switch.module.css';

// ADR 0079 (workflow review D2, Q6b): the phone Screening step is off by default and switched on per job
// from the Shortlist. On, people the manager says yes to (or HR goes ahead with) wait in Screening before
// Contact. Off is refused while anyone is still in it, so nobody is ever lost: the switch says why.

export function PhoneScreenSwitch({ jobId, view }: { readonly jobId: string; readonly view: PhoneScreenView }): ReactNode {
  const { setOn, isSaving } = useSwitchPhoneScreen(jobId);
  const isLocked = view.isOn && view.switchOffBlocked !== null;
  return (
    <div className={styles.wrap}>
      <Switch checked={view.isOn} disabled={!view.canEdit || isSaving || isLocked} label="Phone screening" onChange={(isOn) => void setOn(isOn)} />
      <span className={styles.hint}>
        {isLocked ? (
          <>
            {view.waiting} in Screening, so it stays on.{' '}
            <Link to="/jobs/$jobId/$tab" params={{ jobId, tab: 'phone_screen' }} className={styles.link}>
              Open Screening
            </Link>
          </>
        ) : view.isOn ? (
          'A call before Contact'
        ) : (
          'Off: yes goes straight to Contact'
        )}
      </span>
    </div>
  );
}
